import React, {useState} from "react";
import { useTranslate } from 'react-redux-multilingual'
import { Modal } from "react-bootstrap";
import CustomMadeItemModal from '../modal/CustomMadeItemModal/CustomMadeItemModal'
import {DevpersoMaster} from "@devperso";

const CustomMadeItemBtn = (props) => {
    const t =useTranslate()
    const [show,setShow]=useState(false) 

    const handleClick = () => {
        setShow(true)
    } 

    const closeModal = () =>{
        setShow(false)
        props.setRelanceFocus(Date.now())
    }
    
    return (<>
        <Modal size="xl" show={show} onHide={() => closeModal()}>
            <Modal.Header closeButton>
                <Modal.Title>{t('customMadeItem')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <DevpersoMaster
                    dp_direction={'CdimCustomMadeItemModal'}

                    closeModal={closeModal}
                    disabled={props.disabled}
                    cookies={props.cookies}
                    setCookie={props.setCookie}
                    clientId={props.clientId}
                    cashierId={props.cashierId}
                    posid={props.posid}
                    setCurrentTicket={props.setCurrentTicket}
                    currentTicket={props.currentTicket}
                    expire_date={props.expire_date}
                    peripheriqueParam={props.peripheriqueParam}
                    affichageClient={props.affichageClient}
                >
                    <CustomMadeItemModal 
                        closeModal={closeModal}
                        disabled={props.disabled}
                        cookies={props.cookies}
                        setCookie={props.setCookie}
                        clientId={props.clientId}
                        cashierId={props.cashierId}
                        posid={props.posid}
                        setCurrentTicket={props.setCurrentTicket}
                        currentTicket={props.currentTicket}
                        expire_date={props.expire_date}
                        peripheriqueParam={props.peripheriqueParam}
                        affichageClient={props.affichageClient}
                    />
                </DevpersoMaster>
            </Modal.Body>
        </Modal>
        <div className="position-relative" style={{padding:"1px"}}>
            <div className="col-12 bg-success rounded raccourciPos text-white" onClick={() => handleClick()}>
                <div className="textAlign" style={{width:'100%', height:'100px'}}>
                    {t('customMadeItem').toUpperCase()}
                </div>
            </div>
            {(props.disabled) ?
                <div className="disabled rounded">
                </div>
            :
                false
            }
        </div>
    </>
    )
}

export default CustomMadeItemBtn;  